import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEmailLogsFromAPI } from "../../../services/EmailLogService";

export const fetchEmailLogs = createAsyncThunk(
  "emailLog/fetchEmailLogs",
  async ({ page, perPage, search, columnFilters }, { rejectWithValue }) => {
    try {
      const response = await fetchEmailLogsFromAPI(page, perPage, search, columnFilters);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data email log");
    }
  }
);

const emailLogSlice = createSlice({
  name: "emailLog",
  initialState: {
    emailLogs: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    emailLogSearch: "",
    loading: false,
    error: null,
    totalCount: 0,
    keywordSearch: "",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchEmailLog: (state, action) => {
      state.emailLogSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetEmailLogState: (state) => {
      state.emailLogs = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmailLogs.fulfilled, (state, action) => {
        const emailLogs = action.payload.emailLogs;
        state.loading = false;
        state.emailLogs = emailLogs.data || [];
        state.totalCount = emailLogs.data?.length || 0;
      })
      .addCase(fetchEmailLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchEmailLog, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetEmailLogState } = emailLogSlice.actions;
export default emailLogSlice.reducer;

